import { useContext, useMemo, useState } from 'react'

import { EDITOR_TOOLS } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorContext } from '@editor/contexts/Editor'
import { CircleAnchorProps } from '@editor/interfaces/canvas'
import { useAppDispatch, useAppSelector } from '@editor/store/app'
import { setCursor } from '@editor/store/tool'
import { CircleAnchorIcon } from '@infraloop/common'

export function useAnchors() {
  // Context
  const { selectedTool } = useContext(EditorContext)

  // Store
  const dispatch = useAppDispatch()
  const workingPoints = useAppSelector((root) => root.toolPlaneDetection.workingPoints)

  // States
  const [isClosing, setIsClosing] = useState<boolean>(false)

  // Vars
  const isSelectedTool = useMemo(() => selectedTool === EDITOR_TOOLS.PLANE, [selectedTool])

  /**
   * Setup working point anchors
   */
  const workingPointAnchors = useMemo(() => {
    if (!isSelectedTool || !workingPoints.length) return []

    const anchors: CircleAnchorProps[] = []

    if (workingPoints.length < 3) {
      anchors.push({
        id: 'polygon-working-points-first',
        point: workingPoints[0],
        color: '#777',
        tooltipText: `この平面の作成を完了するには、あと${3 - workingPoints.length}点以上が必要です`,
      })
    } else {
      anchors.push({
        id: 'polygon-working-points-first',
        point: workingPoints[0],
        color: isClosing ? '#ff0000' : '#248CE4',
        icon: CircleAnchorIcon.CHECK,
        iconColor: '#ffffff',
        outlineOpacity: 0,
        scale: 1.3,
        hoverScale: 1.5,
        iconScale: 1.1,
        tooltipText: 'この平面の作成を完了',
        onEnter: () => {
          if (workingPoints.length > 2) {
            dispatch(setCursor(CursorState.POINTER))
            setIsClosing(true)
          }
        },
        onLeave: () => {
          if (workingPoints.length > 2) {
            setIsClosing(false)
            dispatch(setCursor(CursorState.NONE))
          }
        },
      })
    }

    return anchors
  }, [isSelectedTool, workingPoints, isClosing, dispatch])

  return {
    anchors: workingPointAnchors,
    isClosing,
    setIsClosing,
  }
}
